const ITEMS = [
  { value: "17+", label: "Years Experience" },
  { value: "Business Analysis", label: "Requirements Engineering" },
  { value: "Product Strategy", label: "Product Ownership" },
  { value: "Agile Delivery", label: "Scrum & Sprints" },
  { value: "UAT", label: "Quality Readiness" },
];

export default function CredibilityStrip() {
  return (
    <section
      data-testid="credibility-strip"
      aria-label="Credibility"
      className="bg-navy text-cream"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-2 px-6 md:grid-cols-5 md:px-12">
        {ITEMS.map((item, i) => (
          <div
            key={item.value}
            data-testid={`credibility-item-${i}`}
            className={`border-cream/10 py-8 pr-6 md:py-10 ${
              i > 0 ? "md:border-l md:pl-8" : ""
            } ${i % 2 === 1 ? "border-l pl-6 md:pl-8" : ""}`}
          >
            <p
              className={`font-display tracking-tight ${
                i === 0 ? "text-4xl text-rust md:text-5xl" : "text-lg md:text-xl"
              }`}
            >
              {item.value}
            </p>
            <p className="mt-1.5 text-xs uppercase tracking-[0.18em] text-cream/55">
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
